import { SectionLabel } from '@/components/marketing/v2/SectionLabel';

type Step = { title: string; body: string };

const STEPS: ReadonlyArray<Step> = [
  {
    title: 'Active le module',
    body: "Un interrupteur « Troc / reprise » dans les réglages de la boutique. Tant qu'il est éteint, rien ne change pour tes caissiers.",
  },
  {
    title: 'Ajoute la reprise au panier',
    body: "Pendant la vente, ajoute le produit repris et sa valeur négociée. Tu peux cumuler plusieurs reprises sur une même vente.",
  },
  {
    title: "Velko calcule l'appoint",
    body: "Vente moins reprise : le client te doit la différence, ou tu lui rends la monnaie si la reprise vaut plus. Les deux sens sont gérés automatiquement.",
  },
  {
    title: 'Encaisse & restock',
    body: "Tu encaisses l'appoint (espèces, Mobile Money, mixte) et l'article repris repart en stock, prêt à être revendu. Tout est tracé.",
  },
];

export default function TrocHowItWorksV2() {
  return (
    <section className="bg-paper py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <SectionLabel>Comment ça marche</SectionLabel>
        <h2 className="mt-3 max-w-3xl font-marketing-display text-[clamp(30px,4.4vw,56px)] font-bold leading-[1.02] tracking-[-0.035em] text-charcoal-800">
          Quatre étapes. <span className="underline-lime">Zéro calcul à la main.</span>
        </h2>

        <div className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((step, i) => (
            <div
              key={step.title}
              className="flex flex-col gap-4 border-2 border-charcoal-800 bg-white p-6 shadow-neobrutal-4"
            >
              <div className="flex items-center gap-3">
                <span
                  className="flex h-10 w-10 shrink-0 items-center justify-center border-2 border-charcoal-800 bg-lime-500 font-marketing-display text-[18px] font-bold text-charcoal-800"
                  aria-hidden="true"
                >
                  {i + 1}
                </span>
                {i < STEPS.length - 1 && (
                  <span className="hidden h-px flex-1 bg-charcoal-200 lg:block" aria-hidden="true" />
                )}
              </div>
              <h3 className="font-marketing-display text-[18px] font-bold leading-[1.18] tracking-[-0.01em] text-charcoal-800">
                {step.title}
              </h3>
              <p className="font-marketing-body text-[14px] leading-[1.55] text-charcoal-600">
                {step.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
